import {gql} from "apollo-boost";

export const SendNotificationQuery = gql`
    query SendNotification($eventId: Int!, $institutionId: Int!, $scheduleId: Int!, $typeId: Int!, $data: String, $subject: String, $data2: String, $data3: String) {
        sendNotification(eventId:$eventId, institutionId:$institutionId, scheduleId:$scheduleId, typeId:$typeId, data:$data, subject:$subject, data2:$data2, data3:$data3) {
            statusCode
		    message
        }
    }
`;